import { Tooltip } from 'antd';
import References from '../../helpers/Reference';
import { useAuth } from '../Auth/store';
import { showToast } from '../Toast/Toast';
import { MAX_COMPARISON_CHANNELS, useChartComparison } from './comparison.store';
import { ReactComponent as IcoChartComparison } from '../../images/ico_chart_comparison.svg';

export const ComparisonChannelButton = ({ channel, station, start, finish, chartSettings, isChart }) => {
    const permission = useAuth((state) => state.permission);
    const channels = useChartComparison((state) => state.channels);
    const addChannel = useChartComparison((state) => state.addChannel);

    const isAvailable = permission?.permissions?.can_view_tech_data
        && isChart
        && Boolean(channel?.uuid);

    if (!isAvailable)
        return null;

    const isSelected = channels.some((item) => item.uuid === channel.uuid);
    const isLimitReached = channels.length >= MAX_COMPARISON_CHANNELS;

    const onAddChannel = (event) => {
        event.stopPropagation();
        const added = addChannel({
            uuid: channel.uuid,
            station: {
                uuid: station.uuid,
                name: station.name,
                area: station.area,
                district: station.district,
                city: station.city,
                locality: station.locality,
                monitoring_object: station.monitoring_object
            },
            measurer: { ...channel },
            start,
            finish,
            chartSettings: { ...chartSettings }
        });

        if (added) {
            showToast({
                title: 'Добавлено к сравнению',
                description: [station.name, channel.typeName || channel.type].filter(Boolean).join(' · ')
            });
        }
    };

    return (
        <Tooltip
            title={isSelected
                ? 'График уже добавлен к сравнению'
                : isLimitReached
                    ? `Превышено максимальное количество каналов к сравнению: ${MAX_COMPARISON_CHANNELS}`
                    : 'Добавить график к сравнению'}
            placement="bottom"
            color="white"
            overlayInnerStyle={{ color: 'black' }}
            mouseEnterDelay={References.tooltip_delay}
        >
            <button
                type="button"
                className={`chart-comparison-button ml-1${isSelected ? ' is-selected' : ''}`}
                onClick={onAddChannel}
                disabled={isSelected || isLimitReached}
                aria-label="Добавить график к сравнению"
            >
                <IcoChartComparison aria-hidden="true" focusable="false" />
            </button>
        </Tooltip>
    );
};